import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { UiComponent } from '@df/ui/ui.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Product } from '../../product.decorator';

@Component({
    selector: 'product-view-prop65-warning',
    templateUrl: './product-view-prop65-warning.html',
    standalone: true,
    imports: [IfSizeDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewProp65WarningComponent extends UiComponent {
    @Input({ required: true })
    product!: Product<IProductDataV3>;

    /**
     * Get warning notice text
     */
    get notice(): string | undefined {
        return this.product.getAttr('prop_65_notice');
    }

    /**
     * Get warning link URL
     */
    get warningUrl(): string {
        return 'www.P65Warnings.ca.gov';
    }
}
